const showTotalAforosAdded = (id, text) => {
    const span = document.getElementById(id);
    span.innerHTML = text;
};

export { showTotalAforosAdded };